// src/components/DoctorRoute.jsx
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function DoctorRoute({ children }) {
  const { user } = useAuth();
  const isDoctor = !!user?.medico?.id_medico;
  if (!isDoctor) return <Navigate to="/doctor/dashboard" replace />;
  return children;
}
